import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    companyApplication: {
      description:
        'You just need to provide some information from the draft statutes of your client’s company.',
      title: 'Complete the company dossier for your client',
    },
    intro: {
      description:
        'By taking part in our beta program, you will get a preview of the process for creating a company for your clients.',
      title: 'Help us simplify the company creation process',
    },
    next: 'Next',
    outro: {
      description:
        'Your client will receive an email inviting them to create and finalize their account.',
      title: 'And voila!',
    },
    personalInfo: {
      description:
        'French banking law requires us to check your personal information as an agent. This will only take a few minutes.',
      title: 'Then answer some questions about yourself',
    },
    start: 'Start',
  },
  fr: {
    companyApplication: {
      description:
        'Il vous suffit de saisir quelques informations clés à partir du projet de statuts de l’entreprise de votre client·e.',
      title: 'Complétez le dossier de l’entreprise de votre client•e',
    },
    intro: {
      description:
        'En participant à notre programme beta, vous allez pouvoir effectuer en avant-première les démarches de création d’entreprise pour vos client·es.',
      title: 'Aidez-nous à simplifier les démarches de création d’entreprise',
    },
    next: 'Suivant',
    outro: {
      description:
        'Votre client·e recevra un e-mail l’invitant à créer son compte pour finaliser l’ouverture.',
      title: 'Et voilà\u00A0!',
    },
    personalInfo: {
      description:
        'La réglementation bancaire française nous impose de vérifier vos informations personnelles en tant que mandataire. Cela ne dure que quelques minutes.',
      title: 'Répondez ensuite à quelques questions vous concernant',
    },
    start: 'Commencer',
  },
} as const);

export default locales;
